import React, { Fragment } from "react";

const EndDiscussion = ({
  user: { avatar, firstname, lastname, jobtitle, location },
  endDiscussion,
  setEndDiscussion,
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() => setEndDiscussion(false)}
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border green">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="user-online-item">{jobtitle}</li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text">
            Would you like to end the live discussion?
          </div>
          <div className="flex-center">
            <button
              className="user-request-button background-green"
              onClick={() => {
                endDiscussion();
              }}
            >
              <i className="far fa-check-circle fa-sm mr-5"></i>
              Confirm
            </button>
            <button
              className="user-request-button background-green"
              onClick={() => setEndDiscussion(false)}
            >
              <i className="fas fa-times fa-sm mr-5 bold"></i>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EndDiscussion;
